import React from 'react';
import { setCurrentView } from 'core/utils';
import { ExportLabelsViewStore } from 'modules/order/stores';
import { ExportLabelsTemplate } from 'themes/modules/order/pages';

@setCurrentView((rootStore, componentProps) => new ExportLabelsViewStore(rootStore, componentProps), 'exportLabelsViewStore')
class ExportLabels extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ExportLabelsTemplate {...this.props} />;
	}
}

export default ExportLabels;



// WEBPACK FOOTER //
// ./src/modules/order/pages/ExportLabels.jsx